import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';


class MobileNav extends React.Component {
    state = {
      isMenuOpen: false,
    };
  
    handleMenuClick = () => {
      // Toggle the state for the menu
      this.setState((prevState) => ({
        isMenuOpen: !prevState.isMenuOpen,
      }));
  
      // Toggle the class 'open' on elements with class 'menu-Bar'
      const menuBars = document.querySelectorAll('.menu-Bar');
      menuBars.forEach((menuBar) => {
        menuBar.classList.toggle('open');
      });
  
      // Toggle the class 'open' on elements with class 'menuWrap'
      const menuWraps = document.querySelectorAll('.menuWrap');
      menuWraps.forEach((menuWrap) => {
        menuWrap.classList.toggle('open');
      });
  
      // Toggle the class 'ovr-hiddn' on the body element
      document.body.classList.toggle('ovr-hiddn');
    };
  render() {
    return (
        <div>
            {/* Your component's JSX content here */}
            <div className='ctmNavMobile'>
                <div className="marquee">
                    <ul>
                        <li>
                            <h6>
                                <img src="https://habib.edu.pk/dev-library/assets/img/open-hours-icon.svg" className="img-fluid" alt="" />
                                Library Hours
                            </h6>
                            <p>Mon to Fri 8:00 AM to 7:30 PM</p>
                            <p>Working Saturday 8:00 AM to 5:00 PM</p>
                        </li>
                    </ul>
                </div>
                <div className='logoHumbergWrap'>
                <Link to="/" as={Link} className='mobileLogo'>
                  <img src="https://habib.edu.pk/dev-library/assets/img/responsive-logo.svg" className="img-fluid responsive-logo" alt=""/>
                </Link>
                    <div className="menu-Bar" onClick={this.handleMenuClick}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="menuWrap ">
                    <div class="container">
                    <div class="innerWrapMenu">
        
                        <a href="/">Home</a>
                        <Accordion>
                            <Accordion.Item eventKey="01">
                                <Accordion.Header>Explore</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <a href="./CollaborativeWorkingAndLearningSpaces">Collaborative Working and Learning Spaces</a>
                                        </li>
                                        <li>
                                            <a href="./ComputerAndTechnology">Computer and Technology (Equipment)</a>
                                            </li>
                                        <li>
                                            <a href="./PrintingScanningAndPhotocopying">Printing, Scanning and Photocopying</a>
                                            </li>
                                        <li>
                                            <a href="./LibraryService">Library Services</a>
                                            </li>
                                        <li>
                                            <a href="./MakerSpace">Maker Space</a>
                                             </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="02">
                                <Accordion.Header>Find Resources</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <a href="https://catalog.habib.edu.pk/">Book/Catalog</a>
                                            <a href="https://hira.habib.edu.pk/jspui/">HIRA (Habib Institutional Repository & Archive)</a>
                                            <ul className='subItemsMenu'>
                                                <li><a href="./DSSE">DSSE</a></li>
                                                <li><a href="./AHSS">AHSS</a></li>
                                            </ul>
                                            <a href="./FreeOpenAccessResources">Free/Open Access Resource</a>
                                            <a href="./NewspaperMagazine">Newspaper and Magazines</a>
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="03">
                                <Accordion.Header>Research Support</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <a href="./BookSession">Book ‘One on one’ session</a>
                                            {/* <a href="./BookSession">Article Request Form/Inter Library Loan</a> */}
                                            <a href="./EventCalendar">Upcoming Trainings/Workshops</a>
                                            <a href="./SelfLearningResources">Self-Learning Resources</a>
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="04">
                                <Accordion.Header>About</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <a href="./LibraryHours">Library Hours</a>
                                            <a href="./PatronUserPolicies">Patron/User Policies span  </a>
                                            <ul className='subItemsMenu'>
                                                <li><a href="./BorrowingPolicies">Borrowing Policies</a></li>
                                                <li><a href="./ComputerUsePolicy">Computer Use Policy</a></li>
                                                <li><a href="./DiscussionRoomsPolicy">Discussion Rooms Policy</a></li>
                                                <li><a href="./FinesPenalty">General Rules Fines</a></li>
                                            </ul>
                                            <a href="./InternshipAndStudentEmploymentOpportunities">Internship & Student Employment Opportunities</a>
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <a href="./AskaLibrarian">Contact</a>
                        <a href="https://catalog.habib.edu.pk/">Catalog</a>
                        {/* <a href="https://vpn.habib.edu.pk/">Off Campus Access</a> */}
                        <a href="./Faq">FAQ's</a>
                    </div>
                </div>
                </div>
            </div>
            {/* Other JSX elements */}
        </div>
            );
          }
        }
        
        export default MobileNav;
        